export const LOGIN_LINK = 'https://app.shootsta.com/';
export const CONTACT_US_LINK = 'https://shootsta.com/contact/';
export const VIDEO_PRODUCTION_LINK = 'https://shootsta.com/';
export const SIGN_UP_LINK = 'https://signup.shootsta.com/';